import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ResetFilterIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.05799 12.084C4.90631 14.7456 7.33589 16.6673 10.2007 16.6673C13.771 16.6673 16.6654 13.6825 16.6654 10.0007C16.6654 6.31875 13.771 3.33398 10.2007 3.33398C7.80789 3.33398 5.71869 4.67465 4.60093 6.66732M4.05799 6.01602L4.94846 6.87572M6.56435 7.50065H3.33203V4.16732L6.56435 7.50065Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

ResetFilterIcon.displayName = 'ResetFilterIcon';
